/* eslint-disable react/prop-types */
import React from 'react';
import { ArticleGroup } from 'Components/organisms/ArticleGroup';

export const getArticleGroup = ({
  articlesPerRow = 3,
  articleCardProps = {
    excerpt: null,
    datePosition: 'bottom',
  },
  articleCardStyle = 'default',
  blankMessage = null,
  ctaLabel = null,
  ctaUrl = null,
  content = null,
  extraClassNames = null,
  headingSize = 4,
  hideImageMinimalIndex = 3,
  more = {},
  showIndex = false,
  sponsorImage = null,
  sponsorText = null,
  title = null,
}) => {
  if (blankMessage === null && (title === null || content === null || (Array.isArray(content) && content.length === 0))) {
    return false;
  }

  return (
    <ArticleGroup
      articleCardProps={articleCardProps}
      articlesPerRow={articlesPerRow}
      articleCardStyle={articleCardStyle}
      blankMessage={blankMessage}
      content={content}
      ctaLabel={ctaLabel}
      ctaUrl={ctaUrl}
      extraClassNames={extraClassNames}
      headingSize={headingSize}
      hideImageMinimalIndex={hideImageMinimalIndex}
      image={sponsorImage}
      more={more}
      title={title}
      sponsorText={sponsorText}
      showIndex={showIndex}
    />
  );
};
